import styled from "styled-components";

export const FooterElement = styled.footer`
  background-color: #020052;
  margin-top: auto;
  width: 100%;
  height: 116px;
  @media (max-width: 1023px) {
    padding-top: 21px;
    height: auto;
  }
`;
